import { ReactElement } from 'react';
import { Label, SelectSearchContainer } from './styles';
import SelectSearch, { fuzzySearch, SelectSearchOption } from 'react-select-search';
import { useTranslation } from 'react-i18next';
import { multiSelectRenderValue } from '~/helpers/selectSearchRenderValue';

interface NewSelectSearchProps {
  label: string;
  options:SelectSearchOption[];
  onChange: (newValue: string | string[]) => void;
  closeOnSelect?: boolean;
  multiple?: boolean;
  value?: string | string[];
  dataTestId?: string;
}

export function NewSelectSearch({
  closeOnSelect,
  label,
  onChange,
  options,
  multiple,
  value,
  dataTestId,
}: Readonly<NewSelectSearchProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <SelectSearchContainer data-testid={dataTestId}>
      <Label>{label}</Label>
      <SelectSearch
        placeholder={t('selecionar')}
        options={options}
        value={value ?? ''}
        search
        filterOptions={fuzzySearch}
        onChange={(value) => onChange(value as unknown as string | string[])}
        multiple={multiple}
        printOptions="on-focus"
        closeOnSelect={closeOnSelect}
        renderValue={multiSelectRenderValue}
      />
    </SelectSearchContainer>
  );
}
